'use strict';

(() => {
  const destroySlider = (element) => {
    if (element.slider) {
      element.slider.closest('.shopify-section')?.removeEventListener('click', element.onClickHandler);
      element.slider.closest('.shopify-section')?.removeEventListener('keydown', element.onKeyDownHandler);
    }

    if (!element.swiper) {
      return;
    }

    element.swiper.destroy(true, true);
    element.swiper = null;
  };

  const initSlider = (element) => {
    if (!element || typeof window.Swiper === 'undefined') {
      return;
    }

    element.slides = element.querySelectorAll('.grid__item');
    element.slider = element.querySelector('.swiper');
    element.nextBtns = Array.from(element.querySelectorAll('.swiper-button-next'));
    element.prevBtns = Array.from(element.querySelectorAll('.swiper-button-prev'));

    const slidesLength = element.slides.length;

    if (!slidesLength || !element.slider) {
      return;
    }

    destroySlider(element);

    element.swiper = new window.Swiper(element.slider, {
      slidesPerView: 'auto',
      loop: false,
      scrollbar: true,
      spaceBetween: 10,
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        990: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
      },
      on: {
        slideChange: element.updateNavigationButtons,
        init: element.updateNavigationButtons,
      },
    });

    element.setupExternalNavigation();
    element.updateNavigationButtons();
  };

  window.initRelatedProductsBlockSlider = (element) => {
    if (!element) {
      return;
    }

    initSlider(element);

    if (element.__relatedProductsBlockResizeHandler) {
      return;
    }

    element.__relatedProductsBlockResizeHandler = () => {
      initSlider(element);
    };

    window.addEventListener('resize', element.__relatedProductsBlockResizeHandler);
  };
})();
